"use client";

import { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";
import Link from "next/link";
import clsx from "clsx";
import S from "./index.module.scss";
import CustomIcon from "@/components/ui/custom-icon";

type variant = "trBlackToBlack" | "trBlackToBlue" | "trWhiteToBlack" | "trBlueToBlack";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: variant;
  arrow?: boolean;
  reverse?: boolean;
}

export const Button = ({ variant = "trBlackToBlack", className, arrow, reverse, children, ...props }: ButtonProps) => {
  return (
    <button className={clsx(S[variant], { [S["shared--reverse"]]: reverse }, className)} {...props}>
      {children}
      {arrow && <CustomIcon fileName="icon-nav-arrow" />}
    </button>
  );
};

interface ButtonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: variant;
  href: string;
  arrow?: boolean;
  reverse?: boolean;
}

export const ButtonLink = ({
  variant = "trBlackToBlack",
  className,
  href,
  arrow,
  reverse,
  children,
  ...props
}: ButtonLinkProps) => {
  return (
    <Link href={href} className={clsx(S[variant], { [S["shared--reverse"]]: reverse }, className)} {...props}>
      {children}
      {arrow && <CustomIcon fileName="icon-nav-arrow" />}
    </Link>
  );
};
